import { 
    thumbsUp, 
    thumbsDown, 
    questionIcon, 
    suggestionIcon 
  } from '../../../components/common/iconPaths'

const icons: any = {
    like: thumbsUp,
    issue: thumbsDown,
    question: questionIcon,
    suggestion: suggestionIcon
  }


export default function getFeedbackFlows(data: any) {
    return {
        types: (data?.feedbackFlows || []).map((f: any)=>({
                id: f.id,
                title: f.title,
                iconPath: icons[f.type],
                options: (f.options || []).map((o:any)=>({
                    id: o.id,
                    title: o.title
                })),
                placeholder: f.placeholder,
                isAllowToContact: f.isAllowToContact,
                allowToContactTitle: f.allowToContactTitle,
                disclaimer: f.disclaimer
            }))
    }
}